import React, { ReactElement, SVGProps } from "react";
import BaseIcon from "./BaseIcon";

export default function MapPinLineIcon(props: SVGProps<any>): ReactElement {
  return (
    <BaseIcon {...props}>
      <path d="M5.25 21.75h13.5m-6.75-9a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" stroke="currentColor" strokeLinecap="round"
            strokeLinejoin="round" strokeWidth="1.5" />
      <path d="M19.5 9.75c0 6.75-7.5 12-7.5 12s-7.5-5.25-7.5-12a7.5 7.5 0 1 1 15 0v0Z" stroke="currentColor"
            strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
    </BaseIcon>
  );
}
